import "./App.css";
import CssBaseline from "@mui/material/CssBaseline";
import { Navigate, Outlet, createBrowserRouter } from "react-router-dom";
import WidgetDynamicLoading from "./widgets/WidgetDynamicLoading";
import BookNowForm from "./widgets/horecaWidget/BooknowForm";
import { Provider } from "react-redux";
import { store, persistor } from "./store/Store";
import { PersistGate } from "redux-persist/integration/react";
import Paymentfailure from "./widgets/horecaWidget/Paymentfailure";
import PaymentPending from "./widgets/horecaWidget/PaymentPending";
import { Suspense, useEffect } from "react";

import SuccessScreen from "./widgets/feedbackWidget/SuccessScreen";
import OpeningHoursCalendar from "./widgets/openingHours/OpeningHours";
import ReservationCancelResponse from "./widgets/horecaWidget/ReservationCancelResponse";
import BookNowFormTicket from "./widgets/ticketingWidget/BookNowFormTicket";
import BookNowActivities from "./widgets/ActivitiesWidget/BookNowActivities";
import PaymentSuccessActivity from "./widgets/ActivitiesWidget/PaymentSuccessActivity";
import ThemeProviderWrapper from "./theme";
import ConditionalRedirect from "./widgets/horecaWidget/ConndtionalRedirect";
import CancelReservation from "./widgets/horecaWidget/CancelReservation";
import MenuComponent from "./widgets/WebshopWidget/MenuComponent";
import MenuItemListComponent from "./widgets/WebshopWidget/MenuItemListComponent";
import AddToCart from "./widgets/WebshopWidget/AddToCart";
import RecommendationProduct from "./widgets/WebshopWidget/RecommendationProduct";
import Cartdetails from "./widgets/WebshopWidget/CartDetail";
import Checkout from "./widgets/WebshopWidget/Checkout";
import PaymentStatusPage from "./widgets/WebshopWidget/PaymentStatusPage";
import HotelBookNowForm from "./widgets/HotelWidget/HotelBookNowForm";
import BookNowHotelWidget from "./widgets/HotelWidget/BookNowHotelWidget";
import BooknowSalon from "./widgets/salonWidget/BooknowSalon";
import Roomdetails from "./widgets/HotelWidget/Roomdetails";

const hasValidQueryParams = (search) => {
  if (!search) return false;
  const params = new URLSearchParams(search);
  const widgetSetupId = params.get("widgetsetupid");
  const key = params.get("key");
  const resType = params.get("resType");
  const secretKey = params.get("secretkey");
  const reservation=params.get('reservation')
  if (resType == "kitchen") {
    return Boolean(resType);
  }
  if (resType == "cancel") {
    return Boolean(key && secretKey && resType);
  }
  else if(resType == 'feedback'){
    return Boolean(secretKey && resType && reservation);
  }
  return Boolean(widgetSetupId && key && resType);
};

const WidgetWrapper = () => {
  // Here we can extract the search from window location
  const search = window.location.search;

  return hasValidQueryParams(search) ? (
    <WidgetDynamicLoading />
  ) : (
    <Navigate to="/" />
  );
};
export const router = createBrowserRouter(
  [
    {
      path: "/",
      element: (
        <Suspense fallback={<div>Loading...</div>}>
          <Provider store={store}>
            <ThemeProviderWrapper>
              <App />
            </ThemeProviderWrapper>
          </Provider>
        </Suspense>
      ),

      children: [
        {
          path: "/",
          element: <ConditionalRedirect />, // Redirect to base path
        },
        {
          path: "widget",
          element: <WidgetWrapper />, // Use the wrapper component to check for query params
          children: [],
        },
        {
          path: "/successFeedback",
          element: <SuccessScreen />,
        },
        {
          path: "bookSalon",
          element: <BooknowSalon />,
        },
        {
          path: `/`,
          element: <PaymentSuccessActivity />,
        },
        {
          path: "/ReservationCancelSuccess",
          element: <ReservationCancelResponse />,
        },

        {
          path: "/openingHours/:key",
          element: <OpeningHoursCalendar />,
        },
        {
          path: "/bookNow",
          element: <BookNowForm />,
        },
        {
          path: "bookNowTickets",
          element: <BookNowFormTicket />,
        },
        {
          path: "bookNowActivity",
          element: <BookNowActivities />,
        },
        {
          path: "paymentStatusfail",
          element: <Paymentfailure />,
        },
        {
          path: "paymentpending",
          element: <PaymentPending />,
        },
        {
          path: "cancelReservation",
          element: <CancelReservation />,
        },
        {
          path: "/bookNowFormHotel",
          element: <HotelBookNowForm />,
        },
        {
          path: "/HotelWidget",
          element: <BookNowHotelWidget />,
          // element: <ListView />,
        }, 
        {
          path: "webshopMenuItem",
          element: <MenuComponent />,
          children: [
            {
              index: true, // This is the default route when at /webshopMenuItem
              element: <MenuItemListComponent />,
            },
            {
              path: "addtocart",
              element: <AddToCart />,
            },
            {
              path: "recommendedProduct",
              element: <RecommendationProduct />,
            },
            {
              path: "cartdetail",
              element: <Cartdetails />,
            },
            {
              path: "checkout",
              element: <Checkout />,
            },
          ],
        },

        {
          path: "menu",
          index: true, // This is the default route when at /webshopMenuItem
          element: <MenuItemListComponent />,
        },
        {
          path: "addtocart",
          element: <AddToCart />,
        },
        {
          path: "recommendedProduct",
          element: <RecommendationProduct />,
        },
        {
          path: "cartdetail",
          element: <Cartdetails />,
        },
        {
          path: "checkout",
          element: <Checkout />,
        },

        {
          path: "kisoMenuItem",
          element: <MenuComponent />,
          children: [
            {
              index: true,
              element: <MenuItemListComponent />,
            },
          ],
        },
        {
          path: "webshopMenu",
          element: <MenuItemListComponent />,
        },
        {
          path: "payment-status",
          element: <PaymentStatusPage />,
        },
        {
          path: "roomdetails",
          element: <Roomdetails />,
        },
      ],
    },
  ],
  {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    },
  }
);
function App() {
  return (
    <>
      <CssBaseline />
      <Outlet />
    </>
  );
}

export default App;
